import React from 'react';
import styled, { useTheme } from 'styled-components';
import PageLayout from './PageLayout';
import theme, { mobileBreakpoint } from '../theme';
import { StarBadgeWithIcon } from './shared/CommonElements';
import Images from '../assets/Images';
import texts from '../locales/texts';

const HeroSection = styled.section`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin: 40px 0 0 0;
  margin-bottom: 16px;
`;

const HeroTitle = styled.div`
  display: flex;
  margin-bottom: 16px;
  align-items: center;
  white-space: normal;
  word-break: break-word;
`;



const MainTitle = styled.h1`
  font-size: 64px;
  z-index: 1000;
  margin: 0;
  line-height: 1;
  color: ${props => props.theme.colors.primary};
  @media (max-width: ${mobileBreakpoint}px) {
    font-size: 48px;
  }
  @media (max-width: 370px) {
    font-size: 45px;
  }
`;

const Subtitle = styled.h2`
  font-size: 32px;
  z-index: 1000;
  font-style: italic;
  margin: 0 0 24px 0;
  color: ${props => props.theme.colors.secondary};
  @media (max-width: ${mobileBreakpoint}px) {
    font-size: 24px;
  }
`;

// Content Sections (matching AboutMe page style)
const ContentSection = styled.section`
  margin: 60px 0;
  
  @media (max-width: ${mobileBreakpoint}px) {
    margin: 60px 0;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  
  @media (max-width: ${mobileBreakpoint}px) {
    justify-content: center;
    flex-wrap: wrap;
  }
`;

const SectionHeaderStar = styled.img`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  
  @media (max-width: ${mobileBreakpoint}px) {
    margin-left: 0;
    width: 50px;
    height: 50px;
    display: none;
  }
`;

const SectionHeaderStarSecond = styled.img`
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  margin-left: -76px;
  
  @media (max-width: ${mobileBreakpoint}px) {
    width: 90px;
    height: 90px;
    margin-left: unset;
  }
`;

const SectionTitle = styled.h2`
  font-size: 36px;
  font-weight: bold;
  margin: 0;
  color: ${props => props.titleColor || props.theme.colors.secondary};
  display: contents;
  
  @media (max-width: ${mobileBreakpoint}px) {
    font-size: 28px;
    text-align: center;
    display: block;
  }
`;

const SectionHeaderStarContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
  @media (max-width: ${mobileBreakpoint}px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    gap: 12px;
  }
`;

const SectionText = styled.div`
  font-size: 18px;
  line-height: 1.6;
  color: ${props => props.theme.colors.primary};
  margin-right: 76px;
  
  p {
    margin-bottom: 16px;
  
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  strong {
    font-weight: 600;
  }
  
  a {
    color: ${props => props.theme.colors.secondary};
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
  
  @media (max-width: ${mobileBreakpoint}px) {
    margin-right: unset;
  }
`;

const AboutProject = () => {
  const theme = useTheme();
  
  // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  
  return (
    <PageLayout>
      <HeroSection>
        <HeroTitle>
          <StarBadgeWithIcon />
          <MainTitle>Über Mey<wbr></wbr>Teaches</MainTitle>
        </HeroTitle>
        <Subtitle>{texts.aboutProjectSubtitle}</Subtitle>
      </HeroSection>

      <ContentSection style={{ marginTop: '0px' }}>
        <SectionHeader>
          <SectionHeaderStar style={{ opacity: 0 }} src={Images.star1} alt="Star icon" />
          <div>
          <SectionText style={{ marginTop: '0px' }} dangerouslySetInnerHTML={{ __html: texts.aboutProjectDescription }} />

          </div>
        </SectionHeader>
      </ContentSection>
      
      {/* Fehlermeldungen Section */}
      <ContentSection>
        <SectionHeader>
          <SectionHeaderStar style={{ opacity: 0 }} src={Images.star1} alt="Star icon" />
          <div>
            <SectionHeaderStarContainer>
              <SectionHeaderStarSecond src={Images.star1} alt="Star icon" />
              <SectionTitle titleColor={theme.colors.secondary}>{texts.aboutProjectBugReportsTitle}</SectionTitle>
            </SectionHeaderStarContainer>
            <SectionText dangerouslySetInnerHTML={{ __html: texts.aboutProjectBugReportsContent }} />
          </div>
        </SectionHeader>
      </ContentSection>

      {/* Feedback & Anregungen Section */}
      <ContentSection>
        <SectionHeader>
          <SectionHeaderStar style={{ opacity: 0 }} src={Images.star2} alt="Star icon" />
          <div>
            <SectionHeaderStarContainer>
              <SectionHeaderStarSecond src={Images.star2} alt="Star icon" />
              <SectionTitle titleColor={theme.colors.secondary}>{texts.aboutProjectFeedbackTitle}</SectionTitle>
            </SectionHeaderStarContainer>
            <SectionText dangerouslySetInnerHTML={{ __html: texts.aboutProjectFeedbackContent }} />
          </div>
        </SectionHeader>
      </ContentSection>
    </PageLayout>
  );
};

export default AboutProject;

